import { Box, Typography } from '@mui/material'
import NumberFunctions from '../../../core/functions/NumberFunctions'

interface IWithdrawLimitInfoProps {
  withdrawLimitEnabled: boolean
  withdrawLimit: number | null
  withdrawLimitRemaining: number | null
  currency?: 'brl' | 'usd'
}

export function WithdrawLimitInfo({
  withdrawLimitEnabled,
  withdrawLimit,
  withdrawLimitRemaining,
  currency = 'brl',
}: IWithdrawLimitInfoProps) {
  if (!withdrawLimitEnabled) {
    return null
  }

  return (
    <Box width="100%">
      <Typography variant="body2" color="text.secondary">
        Limite mensal de saque:{' '}
        <strong>
          {NumberFunctions.formatMoneyDefault(withdrawLimit ?? 0, currency)}
        </strong>{' '}
        (restam{' '}
        <strong>
          {NumberFunctions.formatMoneyDefault(
            withdrawLimitRemaining ?? 0,
            currency
          )}
        </strong>
        )
      </Typography>
    </Box>
  )
}
